import { patientRPMState } from "app/store/patient/slice/state/patientRPMState";
import { patientTableState } from "app/store/patient/slice/state/patientTableState";
import { patientAction } from "../actions/patientAction";

import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  ...patientTableState,
  ...patientRPMState,
};

const patientSlice = createSlice({
  name: "patient",
  initialState: initialState,
  reducers: patientAction,
});

export const {
  changePage,
  changeOrder,
  changeSearch,
  changeFilters,
  changePageSize,
  onRPMRowChange,
  onBPReadingView,
  toggleFetchTableData,
  togglePatientRPMModal,
  togglePatientEnrollModal,
  onCommunicationLogChange,
  toggleFetchRPMPatientData,
  toggleCommunicationLogCancelModal,
  toggleCommunicationLogDeleteModal,
  refreshDeviceAlertList,
  storeScaleChartData,
  setPagination,
  setSearch,
  togglePatientAlert,
  toggleDeviceAlert,
  toggleMissingContactInfo,
  toggleAlertWhenDisconnected,
  changeSelectedRows,
  toggleModal,
} = patientSlice.actions;

export default patientSlice.reducer;
